// eslint-disable-next-line @typescript-eslint/no-use-before-define
import React from 'react';
import { connect } from 'react-redux';
import { FormDetails, getFormDetails } from '../form-details-reducer';
import styles, { StyledComponent } from '../../../../../styles/styles';
import { Grid, Paper, Typography, withStyles } from '@material-ui/core';
import { State } from '../../../../../redux/root-reducer';

interface BaseProps {
    formDetails?: FormDetails;
}

interface Props extends BaseProps, StyledComponent {}

const GuaranteedPaymentPeriodViewComponent: React.FC<Props> = ({ classes, formDetails }: Props) => {
    const guaranteedPaymentPeriodClaims =
        formDetails?.claimInformation?.guaranteedPaymentPeriodClaims;

    const sections = [
        {
            title: 'Fractures',
            items: guaranteedPaymentPeriodClaims?.fractures,
        },
        {
            title: 'Joint Replacement',
            items: guaranteedPaymentPeriodClaims?.jointReplacement,
        },
        {
            title: 'Hospitalisation and Surgery',
            items: guaranteedPaymentPeriodClaims?.hospitalisationAndSurgery,
        },
        {
            title: 'Cancer',
            items: guaranteedPaymentPeriodClaims?.cancer,
        },
    ].filter(section => section.items?.length);

    return (
        <>
            <Grid container justify="space-between" className={classes.marginTop2}>
                <Grid container item xs={10} alignItems="center">
                    <Typography style={{ padding: 10 }} className={classes.heading} variant="body1">
                        Guaranteed Payment Period Claims
                    </Typography>
                </Grid>
            </Grid>

            <Paper className={classes.paper}>
                <Grid container spacing={4}>
                    {sections.map(section => (
                        <Grid item xs={12} key={section.title}>
                            <Typography
                                variant="subtitle1"
                                style={{
                                    fontWeight: 600,
                                    marginBottom: 12,
                                    paddingBottom: 4,
                                    borderBottom: '1px solid #d9d9d9',
                                    color: '#222',
                                }}
                            >
                                {section.title}
                            </Typography>

                            <Grid container spacing={1}>
                                {section.items?.map((item, index) => (
                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={3}
                                        key={`${section.title}-${index}`}
                                    >
                                        <Typography
                                            variant="body2"
                                            style={{
                                                lineHeight: 1.7,
                                                color: '#333',
                                                wordBreak: 'break-word',
                                            }}
                                        >
                                            {item}
                                        </Typography>
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
            </Paper>
        </>
    );
};

const mapStateToProps = (state: State, ownProps: BaseProps) => ({
    formDetails: ownProps.formDetails ?? getFormDetails(state),
});

const mapDispatchToProps = {};

export const GuaranteedPaymentPeriodView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(GuaranteedPaymentPeriodViewComponent));
